import React from "react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import Hero from "../components/site/Hero";
import VisionMission from "../components/site/VisionMission";
import Founder from "../components/site/Founder";
import Courses from "../components/site/Courses";
import WhyChooseValues from "../components/site/WhyChooseValues";
import Gallery from "../components/site/Gallery";
import Anthem from "../components/site/Anthem";
import Testimonials from "../components/site/Testimonials";
import LocationRating from "../components/site/LocationRating";
import Contact from "../components/site/Contact";

export default function Home() {
    return (
        <div data-testid="home-page" className="bg-ivory text-ink">
            <Navbar />
            <main>
                <Hero />
                <VisionMission />
                <Founder />
                <Courses />
                <WhyChooseValues />
                <Gallery />
                <Anthem />
                <Testimonials />
                <LocationRating />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
